export default function Icon({ name, className = "", size }) {
  const props = size ? { width: size, height: size } : {};
  return (
    <svg
      className={className ? `icon ${className}` : "icon"}
      {...props}
      aria-hidden="true"
    >
      <use href={`#${name}`} />
    </svg>
  );
}
